export default "__VITE_ASSET__f611b8c5__"